/*!
 * jQuery Sequencer Plugin v2.0.0 - Image sequencer
 * @AUTHOR: Clément Caillard
 * Thanks to Nicolas Riciotti
 *
 * Who's Your Daddy ? Bang bang bang !
 */

//TODO: supprimer jquery: utilisé seulement pour faire un extend et initialiser $element
//TODO option pour forcer les HD à tester ?
//TODO option pour forcer image plutot que canvas ?
//TODO gestion digit 001 002 etc !!!

/*! IE8- bind polyfill */
Function.prototype.bind = Function.prototype.bind || function(b) {if (typeof this !== "function") {throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");}var a = Array.prototype.slice,f = a.call(arguments, 1),e = this,c = function() {},d = function() {return e.apply(this instanceof c ? this : b || window, f.concat(a.call(arguments)));};c.prototype = this.prototype;d.prototype = new c();return d;};

(function($, window, undefined) {
    "use strict";

    var Sequencer = function(target, options, callback) {

        this.options = $.extend({
            sdJson: "",
            hdJson: "",
            sdPath: "medias/sequence/image_#.jpg", // '#' will be replaced by digit (ex: 000, 001, 002, 012, 112)
            hdPath: "", // if empty, no quality switch
            imageCount: 0, // nombre d'image dans la séquence
            startIndex: 0,
            switchQualityDelay: 200,
            maxParallelPreload: 5 // to parallelize images preload (http-max-connection = 6 for recent browser)
        }, options || {});

        this.options.imageCount = parseInt(this.options.imageCount, 10);
        this.options.startIndex = parseInt(this.options.startIndex, 10);
        this.options.switchQualityDelay = parseInt(this.options.switchQualityDelay, 10);
        this.options.maxParallelPreload = parseInt(this.options.maxParallelPreload, 10);

        this.target = target;
        this.$element = $(this.target)[0];
        this.useHD = (this.options.hdPath !== ""); // should we display HD images on pause
        this.imageSDArr = new Array(this.options.imageCount);
        this.imageHDArr = (this.useHD) ? [] : null;
        this.currentIndex = -1;
        this.nextIndexToLoad = 0;
        this.imageSDToLoadCount = this.options.imageCount; // nombre d'images SD restantes à loader
        this.timerSwitchQuality = null;
        var tmpCanvas = document.createElement('canvas');
        this.supportCanvas = !!(tmpCanvas.getContext && tmpCanvas.getContext('2d'));
        this.timerAutoplay = null;
        this.isPlaying = false;

        if (this.supportCanvas) {
            this.$canvas = null;
            this.canvasContext = null;
            this.resizeCanvasTimer = null;
            this.createCanvas();
        } else {
            this.$image = null;
            this.createImage();
        }

        // Display first image
        this.update(this.options.startIndex);

        // Preload next images in parallel
        if (this.options.maxParallelPreload > 1) {
            for (var i = 0; i < this.options.maxParallelPreload; i++) {
                this.preloadNextImage();
            }
        }

        // Callback
        if (typeof(callback) == "function") {
            callback.call(this);
        }
    };

    Sequencer.prototype = {

        createImage: function() {
            this.$image = document.createElement("img");
            this.$element.appendChild(this.$image);
        },

        createCanvas: function() {
            this.$canvas = document.createElement("canvas");
            this.$element.appendChild(this.$canvas);
            this.canvasContext = this.$canvas.getContext("2d");
            this.canvasContext.imageSmoothingEnabled = true; //TODO faire des test de perf ou mettre false
            this.resizeCanvas();
            $(window).on('resize', this.resizeCanvas.bind(this));
        },

        resizeCanvas: function() {
            var self = this;

            clearTimeout(this.resizeCanvasTimer);
            this.resizeCanvasTimer = setTimeout(function() {
                self.$canvas.setAttribute("width", self.$element.offsetWidth + "px");
                self.$canvas.setAttribute("height", self.$element.offsetHeight + "px");
                if (this.useHD) {
                    self.preloadImage(self.currentIndex, self.displayImage.bind(self), true);
                }
            }, 50);
        },

        preloadImage: function(index, callback, hd) {
            var self = this;
            var callback = (typeof callback == "function") ? callback : function() {};
            var cachedImage = (hd) ? this.imageHDArr[index] : this.imageSDArr[index];
            var isJson = (this.options.sdJson) ? true : false;
            var src = isJson ? this.options[(hd) ? "hdJson" : "sdJson"][index] : this.options[(hd) ? "hdPath" : "sdPath"].replace('#', index);

            this.nextIndexToLoad = index + 1;

            if (typeof(cachedImage) == "object") {
                // Image already loaded
                callback(index, hd);
            } else {
                // Image need to be preloaded
                if (!cachedImage) {

                    if (hd) {
                        self.imageHDArr[index] = true; // Loading in progress
                    } else {
                        this.imageSDToLoadCount--;
                        self.imageSDArr[index] = true; // Loading in progress
                    }

                    // Preloading
                    var img = new Image();
                    img.onload = function() {
                        // Image loaded
                        this.onload = null; // Remove listener to save memory

                        if (hd) { //TODO vérifier que stocker les HD ne casse pas les perf (IPAD)
                            self.imageHDArr[index] = this;
                            //self.imageSDArr[index] = this;//TODO pour remplacer les sd par les hd qd celle ci sont loadé. TESTER les perf !!!! (ipad hebergement etc avec une vrai sequence)
                        } else {
                            self.imageSDArr[index] = this;
                        }

                        callback(index, hd);
                    };
                    img.src = src;
                }
                /*else {
                    // loading process already in progress
                }*/
            }
        },

        update: function(index) {
            if (this.currentIndex !== index && index >= 0 && index < this.options.imageCount) {
                clearTimeout(this.timerSwitchQuality); //TODO: if (this.useHD) ?
                this.currentIndex = index;
                this.preloadImage(index, this.displayImage.bind(this), false); // On preload l'image SD puis on l'affiche
            }
        },

        start: function(timer, loop) {
            var self = this;
            var nextIndex = this.currentIndex;
            this.isPlaying = true;

            clearInterval(this.timerAutoplay);
            this.timerAutoplay = setInterval(function() {
                nextIndex++;

                if (nextIndex >= self.options.imageCount) {
                    if (loop) {
                        nextIndex = 0;
                    } else {
                        self.stop();
                        return;
                    }
                }

                self.update(nextIndex);
            }, timer);
        },

        stop: function(stopIndex) {
            clearInterval(this.timerAutoplay);
            this.isPlaying = false;
            if (stopIndex !== false && stopIndex >= 0 && stopIndex < this.options.imageCount) {
                this.update(stopIndex);
            }
        },

        displayImage: function(index, hd) {
            var self = this;

            if (this.currentIndex === index) {
                var cachedImage = (hd) ? this.imageHDArr[index] : this.imageSDArr[index];

                // On met à jour l'image
                if (this.supportCanvas) {
                    var w = this.$canvas.width << 0;
                    var h = this.$canvas.height << 0;
                    this.canvasContext.clearRect(0, 0, w, h);
                    this.canvasContext.drawImage(cachedImage, 0, 0, w, h);
                } else {
                    this.$image.src = cachedImage.src;
                }

                // Si on est en SD, on prépare l'affiche HD et on preload la suite de la séquence
                if (!hd) {
                    this.preloadNextImage();

                    if (this.useHD) {
                        this.timerSwitchQuality = setTimeout(function() {
                            self.preloadImage(index, self.displayImage.bind(self), true); // On preload l'image HD puis on l'affiche
                        }, this.options.switchQualityDelay);
                    }
                }
            }
        },

        preloadNextImage: function() {
            if (this.imageSDToLoadCount) {
                if (this.nextIndexToLoad >= this.options.imageCount) {
                    this.nextIndexToLoad = 0;
                }

                this.preloadImage(this.nextIndexToLoad, this.preloadNextImage.bind(this), false);
            }
            /* else {
                //TODO: sequence loaded (dispatch event ?)
                //TODO: on preload les images HD ?
            }*/
        }
    };

    window.Sequencer = Sequencer;

})(jQuery, window);
